import EmptyPage from "../../../components/empty-page/empty-page.component";

const FinalAttestation = () => (
  <EmptyPage title="Результати підсумкової атестації" />
);

export default FinalAttestation;
